import React, { useContext, useEffect, useState } from "react";
import { ListProps } from "./index";
import { Title } from "../../../../../stories/Title/Title";
import {
  HEADER_TEXT_ALIGN,
  SLNO_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../styles/Variables";
import { TableHeaderProps } from "../../../../../utils/types";
import { GridColDef, GridValidRowModel } from "@mui/x-data-grid-pro";
import { Operation, TableHeaders } from "../../../../../utils/Enum.types";
import Edit from "../../../../../images/EditProfile.svg";
import Delete from "../../../../../images/Delete.svg";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import {
  DeleteEmailConfigResult,
  DeleteEmailConfigVar,
  GetEmailConfig,
  GetEmailConfigResult,
  GetEmailConfigVar,
} from "./queries/types";
import { GetEmailConfigs } from "./queries/queries";
import { useLazyQuery, useMutation } from "@apollo/client";

import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import DeleteModal from "../../../../../customComponents/DeleteModal";
import { DeleteEmailConfig } from "./queries/mutations";
import { emptyMessage } from "../../../../../utils/constants";
import MessageModal from "../../../../../customComponents/MessageModal";
import { AppContext } from "../../../../../context/context";
import { payloadTypes } from "../../../../../context/reducer";
import LoadingModal from "../../../../pages/LoadingModal";

const List = ({ setOperation, setForm }: ListProps) => {

  const { user_details } = useLoggedInUserDetails();
  const { customer_id } = useUrlParams();
  const { dispatch } = useContext(AppContext);
  const [deleteModal, setDeleteModal] = useState(false);
  const [emailConfigId, setEmailConfigId] = useState(0);
  const [message, setMessage] = useState(emptyMessage);

  const [rows, setRows] = useState<GridValidRowModel[]>([]);

  const [getEmailConfig, { data, loading }] = useLazyQuery<
    GetEmailConfigResult,
    GetEmailConfigVar
  >(GetEmailConfigs);

  const [deleteEmailConfig,{loading:DeleteEmailConfigLoading}] = useMutation<
    DeleteEmailConfigResult,
    DeleteEmailConfigVar
  >(DeleteEmailConfig, {
    onError: (e) =>
      setMessage({ message: e.message, flag: true, operation: Operation.NONE }),
  });

  const dynamicHeaders: TableHeaderProps[] = [
    {
      headerName: "Sl",
      field: "id",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
    },
    {
      headerName: `Form`,
      field: "from",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      flex: 1,
      hideable: false,
    },
    {
      headerName: `Password`,
      field: "password",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      flex: 1,
      hideable: false,
    },
    {
      headerName: `Smtp Host`,
      field: "smtpHost",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      flex: 1,
      hideable: false,
    },
    {
      headerName: `Smtp Port`,
      field: "smtpPort",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      flex: 1,
      hideable: false,
    },
  ];

  const columns: GridColDef[] = [
    ...dynamicHeaders,
    {
      headerName: TableHeaders.ACTION,
      field: "actions",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      renderCell: (params) => {
        return (
          <>
            <img
              src={Edit}
              alt=""
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_EMAIL_CONFIG_ID,
                  payload: {
                    emailConfigId: params.row.id,
                  },
                });
                setForm(() => ({
                  from: params.row.from,
                  password: params.row.password,
                  smtpHost: params.row.smtpHost,
                  smtpPort: params.row.smtpPort,
                }));
                setOperation(Operation.UPDATE);
              }}
            />
            <img
              src={Delete}
              alt=""
              onClick={() => {
                setEmailConfigId(params.row.id);
                setDeleteModal(!deleteModal);
              }}
            />
          </>
        );
      },
    },
  ];

  const handleClose = () => {
    setMessage(emptyMessage);
  };

  const HandleDelete = async (id: number) => {
    setDeleteModal(false);
      if (id && customer_id) {
        deleteEmailConfig({
          variables: {
            
            emailConfigId: id,
            user_details,
          },
          refetchQueries: [
            {
              query: GetEmailConfigs,
              variables: {
                
                customerId: customer_id,
              },
            },
          ],
        }).then(({ data }) => {
          if (data)
            setMessage({
              message: "Delete Email config successfully",
              flag: true,
              operation: Operation.DELETE,
            });
        });
      }
  };

  useEffect(() => {
    if (customer_id) {
      getEmailConfig({
        variables: {
          
          customerId: customer_id,
        },
      }).then(({ data }) => {
        if (data) {
          const datas: GetEmailConfig = data.GetEmailConfig;
          setRows([datas]);
        }
      });
    }
  }, [getEmailConfig, customer_id]);

  useEffect(() => {
    if (data && !loading) {
      setRows([data.GetEmailConfig]);
    }
  }, [data, loading]);

  return (
    <>
      <div className="master-data__list">
        <Title variant="subtitle1">List Email Config</Title>
        <div className="master-data__list--tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            // onCellClick={(params) => {
            //   if (params.field === "months") {
            //     setViewModal(!viewModal);
            //     handleFilterMonthDetails(params.row.month_id);
            //   }
            // }}
            disableRowSelectionOnClick
            hideFooter
          />
        </div>
      </div>

      {/* <LoadingModal flag={deletionLoading} /> */}

      <DeleteModal
        id={emailConfigId}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={HandleDelete}
      />
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal flag={loading || DeleteEmailConfigLoading} />
    </>
  );
};

export default List;
